import { get } from "@/request/http";

// 获取学校列表
export { getSchoolList } from "../public/school";

// 邮箱认证发送邮件
export const emailAuth = p => get("/login/emailAuth", p);

// 校外用户注册接口
export const outSchoolRegister = p => get("/login/outSchoolRegister", p);
